import type { Components, Theme } from '@mui/material';

export const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: () => ({
      '& span': {
        fontSize: '1.4rem',
        '& .MuiSvgIcon-root': {
          height: '2.5rem',
          width: '2.5rem',
        },
      },
    }),
  },
};
